import React from 'react';
import { getLabel } from '../../InitData';

export default function LiveScoresDisclaimer(props) {
    const disclaimer = getLabel('live_scores_disclaimer');

    if (disclaimer.length === 0) {
        return null;
    }

    return (
        <div className="live-scores-disclaimer">
            {disclaimer}
        </div>
    );
}
